import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIFeatureModels } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { FEATURE_MODELS_QUERY_KEY } from "./useFeatureModels";
export const updateFeatureModels = (settings) => AIFeatureModels.setAll({ settings });
const useUpdateFeatureModels = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const mutation = useMutation({
    mutationFn: updateFeatureModels,
    onSuccess: (_featureModels, settings) => {
      settings.forEach(
        ({ feature_id, setting }) => sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.FEATURE_MODEL_CHANGED, {
          app_section: "aiagent-feature-models",
          event_details: {
            feature_id,
            provider: setting.provider,
            model: setting.model_id
          }
        })
      );
      UserNotification.success("Feature model settings saved.");
      queryClient.invalidateQueries({ queryKey: FEATURE_MODELS_QUERY_KEY });
    },
    onError: (error) => UserNotification.error(`Changing feature models failed: ${error.message}`)
  });
  return { updateFeatureModels: mutation.mutateAsync };
};
export default useUpdateFeatureModels;
